
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prosody",
      function () {
        return require("private-next-pages/prosody/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prosody"])
      });
    }
  